import { render, staticRenderFns } from "./NewAgentForm.vue?vue&type=template&id=18723805&"
import script from "./NewAgentForm.vue?vue&type=script&lang=js&"
export * from "./NewAgentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports